import React, { useEffect, useRef, useState } from "react";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TpStudioHeader from "../../client/tp-studio/tp-studio-header";
import TPStudioSidebar from "../../client/tp-studio/TPStudioSidebar";
import TpStudioLoader from "../../client/tp-studio/tp-studio-loader";
import reconnecting from "../../../assets/topstudio/images/rolet/reconnecting.gif";
import "../../../assets/topstudio/styles/Player.css";
import useSocket from "../../../hooks/useSocket";
import useClosedPhaseOverlay from "../../../hooks/useClosedPhaseOverlay";
import TeenPattisCasinoBetslipWeb from "./teenpatti_casino_betslip_web";
import TPPopUpBetSlip from "./teenpatti_casino_betslip_popup.jsx";
import axiosInstance from "../../../utils/axiosInstance";
import BollywoodResult from "../../client/tp-studio/tp-result/BollywoodResult.jsx";
import { isMobile } from "react-device-detect";
import BollywoodRules from "./pop-up/bollywood-rules.jsx";
import Volume from "./Volume";

import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";

export default function BollywoodVirtual() {
  const dispatch = useDispatch();
  const [stakeLimit, setStakeLimit] = useState(0);
  const [showRules, setShowRules] = useState(false);
  const [activeTabIndex, setActiveTabIndex] = useState(1);
  const [showBetSlip, setShowBetSlip] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [betErrorMessageObj, setBetErrorMessage] = useState({});
  const [open, setOpen] = useState(false);
  const [displayLoader, setDisplayLoader] = useState(true);
  const [roundId, setRoundId] = useState("");

  const [amarakbaranthony, setAmarakbaranthony] = useState(0);
  const [dharamveer, setDharamveer] = useState(0);
  const [done, setDone] = useState(0);
  const [ghulam, setGhulam] = useState(0);
  const [kiskiskopyarkaru, setKiskiskopyarkaru] = useState(0);
  const [sahibbibiaurghulam, setSahibbibiaurghulam] = useState(0);

  const [dulhadulhan, setDulhadulhan] = useState(0);
  const [barati, setBarati] = useState(0);
  const [red, setRed] = useState(0);
  const [black, setBlack] = useState(0);
  const [cardj, setCardj] = useState(0);
  const [cardq, setCardq] = useState(0);
  const [cardk, setCardk] = useState(0);
  const [carda, setCarda] = useState(0);

  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [betButtonShow, setBetButtonShow] = useState(true);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);
  const [resultList, setResultList] = useState([]);

  const [oddsData, setOddsData] = useState([]);
  const [lastStatus, setLastStatus] = useState(null);

  const [resultData, setResultData] = useState([]);
  /* ================= TIMER ================= */
  const TOTAL_SECONDS = 30;
  const [timeLeft, setTimeLeft] = useState(TOTAL_SECONDS);
  const localTimerRef = useRef(null);

  /* ================= SINGLE CARD STATE ================= */
  const [shownCard, setShownCard] = useState("1");
  const [shouldFlip, setShouldFlip] = useState(false);
  const lastEvtStatusRef = useRef(null);

  const sessionUser = useSelector((s) => s.userStore.data);
  const updateUserData = async (userData) => {
    if (!userData || !sessionUser) return;
    await dispatch(
      setUserData({
        ...sessionUser,
        fname: userData.fname ?? sessionUser.fname,
        uname: userData.uname ?? sessionUser.uname,
        bz_balance: userData.bz_balance ?? sessionUser.bz_balance,
        opin_bal: userData.opin_bal ?? sessionUser.opin_bal,
        user_role: sessionUser.user_role,
        _id: sessionUser._id
      })
    );
  };

  /* ================= SOCKET ================= */
  const { data } = useSocket({
    marketId: null,
    mtype: "teenpatti",
    type: "bollywood_virtual"
  });

  const payload = data?.data?.data;

  const result = Number(payload?.result);

  const resultReady =
    payload?.evt_status === "CLOSED" &&
    payload?.c1 &&
    payload?.c1 !== "1";

  const donWinner = result === 1;
  const amarAkbarAnthonyWinner = result === 2;
  const sahibBibiAurGulamWinner = result === 3;
  const dharamVeerWinner = result === 4;
  const kisKiskoPyaarKaroonWinner = result === 5;
  const ghulamWinner = result === 6;
  const kqWinner = Number(payload?.KQ) === 1;
  const jaWinner = Number(payload?.JA) === 1;
  const redWinner = Number(payload?.Red) === 1;
  const blackWinner = Number(payload?.Black) === 1;
  const jCardWinner = Number(payload?.JCard) === 1;
  const qCardWinner = Number(payload?.QCard) === 1;
  const kCardWinner = Number(payload?.KCard) === 1;
  const aCardWinner = Number(payload?.ACard) === 1;

  const { isSuspended, suspendedText } = useClosedPhaseOverlay(
    payload?.evt_status,
    payload?.cat_mid,
    setShowBetSlipPopup
  );
  const payloadResult = data?.data?.result;

  //console.log("data:", JSON.parse(payload?.child_array)[0]); // DO NOT REMOVE

  const payloadOdds = JSON.parse(payload?.child_array || "[]");
  // console.log("data:", payload); // DO NOT REMOVE
  //console.log("data:", payload); // DO NOT REMOVE
  /* ================= TIMER + VALUES ================= */
  useEffect(() => {
    if (!payload || !payloadOdds) return;
    updateUserData(data?.user);
    setDisplayLoader(false);
    if (lastStatus !== payload.evt_status && payload.evt_status === "OPEN") {
      setPlacedBets([]);
      setAmarakbaranthony(0);
      setDharamveer(0);
      setDone(0);
      setGhulam(0);
      setKiskiskopyarkaru(0);
      setSahibbibiaurghulam(0);
      setDulhadulhan(0);
      setBarati(0);
      setRed(0);
      setBlack(0);
      setCardj(0);
      setCardq(0);
      setCardk(0);
      setCarda(0);
    }

    if (lastStatus !== payload.evt_status) {
      setLastStatus(payload.evt_status);
    }
    //console.log("payloadOdds:", payloadOdds[0]?.back);
    setOddsData(payloadOdds);
    setRoundId(payload?.cat_mid);
    const serverSeconds = payload?.left_time;
    if (typeof serverSeconds === "number") {
      setTimeLeft(serverSeconds);
    }

    clearInterval(localTimerRef.current);
    localTimerRef.current = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
  }, [payload]);

  useEffect(() => () => clearInterval(localTimerRef.current), []);

  /* ================= SINGLE CARD UPDATE + FLIP ================= */
  useEffect(() => {
    if (!payload?.evt_status) return;

    if (payload.evt_status === "OPEN") {
      setShownCard("1");
      setShouldFlip(false);
      lastEvtStatusRef.current = payload.evt_status;
      return;
    }

    if (payload?.c1) {
      setShownCard(payload.c1);
    }

    if (payload.evt_status === "CLOSED" && payload.c1 != "1") {
      setShouldFlip(true);
    } else {
      setShouldFlip(false);
    }

    lastEvtStatusRef.current = payload.evt_status;
  }, [payload?.evt_status, payload?.c1]);

  /* ================= SVG TIMER ================= */
  const R = 45;
  const CIRC = 2 * Math.PI * R;
  const dash = Math.max(0.0001, CIRC * (timeLeft / TOTAL_SECONDS));
  const timerColor =
    timeLeft <= 5 ? "red" : timeLeft <= 10 ? "orange" : "green";

  /* ================= BET SLIP ================= */
  const showBetfairBetSlip = (
    bettype,
    teamname,
    selectRnr,
    price,
    marketTypeVal,
    sid
  ) => {
    let obj = {
      amount: 0,
      catmid: payload?.cat_mid,
      round: payload?.cat_mid,
      odds: price,
      teamname,
      bettype,
      selectRnr,
      marketVal: 1,
      game_name: "bollywood_virtual",
      market_type: marketTypeVal,
      sid: sid
    };

    setPlaceBetObject(obj);
    if (isMobile) {
      setShowBetSlipPopup(true);
    } else {
      setShowBetSlip(true);
    }
  };

  const closeBetSlip = () => setShowBetSlip(false);

  const [profileData, setProfileData] = useState(null);
  const [placedBets, setPlacedBets] = useState([]);
  const [initialBetsFetched, setInitialBetsFetched] = useState(false);

  const fetchProfile = async () => {
    const { data } = await axiosInstance.get("/profile");
    setProfileData(data);
  };

  const betStakeLimit = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/bet-stake-limit");
      if (data != null && data !== undefined) {
        let limit = data?.myBetLimit?.teenpatiStudio;
        setStakeLimit(formatTruncate(limit));
      }
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };

  const activeTab = async (tab1) => {
    setActiveTabIndex(tab1);
    if (tab1 == 2) {
      showResultDetail();
    }
  };

  useEffect(() => {
    if (!payloadResult) return;

    if (payloadResult !== "") {
      //console.log("payloadResult->", payloadResult);
      setResultList([]);
      setResultList(payloadResult);
    }
  }, [payloadResult]);

  async function getPlacedBets() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-placed-bets", {
      cat_mid: payload.cat_mid,
      gametype: "bollywood_virtual"
    });
    setPlacedBets(res.data);
  }

  useEffect(() => {
    fetchProfile();
    betStakeLimit();
  }, []);

  useEffect(() => {
    if (!initialBetsFetched && payload?.cat_mid) {
      getPlacedBets();
      getBook();
      setInitialBetsFetched(true);
    }
  }, [payload]);

  const placeBet = async (amount, profit) => {
    placeBetObject.amount = amount;
    placeBetObject.profit = profit;
    // placeBetObject.sid1 = payload?.sid1;
    // placeBetObject.sid2 = payload?.sid2;
    // placeBetObject.sid3 = payload?.sid3;

    try {
      const response = await axiosInstance.post(
        "/casino/place-bet-casino",
        placeBetObject
      );

      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.status !== undefined &&
        response.data.status !== null
      ) {
        let messageObj = {};
        if (response.data.status) {
          messageObj.status = true;
          getPlacedBets();
          setShowBetSlipPopup(false);
          getBook();
        } else {
          messageObj.status = false;
        }
        messageObj.message = response.data.message;
        setBetErrorMessage(messageObj);
      }
    } catch (error) {
      if (error.response.data !== undefined && error.response.data !== null) {
        if (
          error.response.data.status !== undefined &&
          error.response.data.status !== null &&
          error.response.data.status === false
        ) {
          let errorMessage = error.response.data.message;
          let messageObj = {};
          messageObj.status = false;
          messageObj.message = errorMessage;
          setBetErrorMessage(messageObj);
        }
      }
    }
  };

  async function getBook() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-book", {
      cat_mid: payload.cat_mid,
      gametype: "bollywood_virtual"
    });
    let books = res?.data;

    if (books !== null && books.length > 0) {
      for (let i = 0; i < books.length; i++) {
        let obj = books[i];
        if (obj.type === 1) {
          setAmarakbaranthony(obj.amarakbaranthony);
          setDharamveer(obj.dharamveer);
          setDone(obj.done);
          setGhulam(obj.ghulam);
          setKiskiskopyarkaru(obj.kiskiskopyarkaru);
          setSahibbibiaurghulam(obj.sahibbibiaurghulam);
        }
        if (obj.type === 2) {
          if (obj.rnrname == "barati") {
            setBarati(obj.lay);
          } else if (obj.rnrname == "dulha dulhan") {
            setDulhadulhan(obj.lay);
          } else if (obj.rnrname == "red") {
            setRed(obj.lay);
          } else if (obj.rnrname == "black") {
            setBlack(obj.lay);
          } else if (obj.rnrname == "card j") {
            setCardj(obj.lay);
          } else if (obj.rnrname == "card q") {
            setCardq(obj.lay);
          } else if (obj.rnrname == "card k") {
            setCardk(obj.lay);
          } else if (obj.rnrname == "card a") {
            setCarda(obj.lay);
          }
        }
      }
    }
  }

  const displayRunnerName = (runnerName) => {
    return runnerName
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const getBollywoodWinnerName = (card) => {
    if (!card || card === "1") return null;

    const normalized = String(card).toUpperCase();

    if (normalized === "AHH") return "Don";
    if (normalized === "ASS" || normalized === "ACC" || normalized === "ADD") {
      return "Amar Akbar Anthony";
    }
    if (normalized === "KHH" || normalized === "QHH" || normalized === "JHH") {
      return "Sahib Bibi Aur Gulam";
    }
    if (normalized === "KSS" || normalized === "KCC") return "Dharam Veer";
    if (
      normalized === "KDD" ||
      normalized === "QCC" ||
      normalized === "QSS" ||
      normalized === "QDD"
    ) {
      return "Kis Kisko Pyaar Karoon";
    }
    if (normalized === "JDD" || normalized === "JCC" || normalized === "JSS") {
      return "Ghulam";
    }

    return null;
  };

  const getWinnerTitle = () => {
    if (payload?.evt_status === "OPEN") return "Winner";

    const activeCard = payload?.c1 ?? shownCard;
    const winnerName = getBollywoodWinnerName(activeCard);
    return winnerName ? `Winner = ${winnerName}` : "Winner";
  };

  /// result detail ///
  const showResultDetail = async () => {
    let resultObj = {};
    resultObj.game_type = "bollywood_virtual";

    const response = await axiosInstance.post("/teenpatti-results", resultObj);

    setResultData(response.data.results_list);
    //console.log("response->", resultData);
  };
  /// result detail ///

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  //console.log("resultList:", resultList);

  return (
    <div className="aviator-scope player-scope aviator-bg-black bollywood-virtual-scope">
      <ClientLayoutWithOutHeader showLoader={false}>
        <div class="details-tabs-wrapper1">
          <div className="main-page">
            <div className="row no-gutters">
              <div className="col-md-12">
                <div className="bodyheight">
                  <div className="wrapper">
                    <TPStudioSidebar open={open} />
                  </div>

                  <div className="lobby-ctn BPGmaindiv">
                    <TpStudioHeader setOpen={setOpen} open={open} />
                    <TpStudioLoader displayLoader={displayLoader} />
                  </div>

                  <div
                    className="row"
                    style={{ display: displayLoader ? "none" : "" }}
                  >
                    <div className="col-md-8">
                      <div className="left-content mob-margin">
                        <div>
                          <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer h-45">
                            <div className="col-6 col-md-6 titlebarname  inline-block Gameidcol mt-2">
                              <p>BOLLYWOOD CASINO</p>
                            </div>
                            <div
                              className="col-6 col-md-6 inline-block Gameidcol text-right"
                              style={{ marginTop: "4px" }}
                            >
                              <div
                                role="group"
                                aria-label="Second group"
                                className="btn-group btn-group-sm mr-2"
                              >
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  id="Alltab"
                                  className={
                                    activeTabIndex == 1
                                      ? "tablink btn btn-primary bbactive"
                                      : "tablink btn btn-primary"
                                  }
                                  onClick={() => activeTab(1)}
                                >
                                  Game
                                </button>
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  id="RESULTStab"
                                  className={
                                    activeTabIndex == 2
                                      ? "tablink btn btn-primary bbactive"
                                      : "tablink btn btn-primary"
                                  }
                                  onClick={() => activeTab(2)}
                                >
                                  Results
                                </button>
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  className="tablink btn btn-primary"
                                  onClick={() => setShowRules(true)}
                                >
                                  Rules
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="cards-layout blackjack"
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div>
                            <div
                              className="cards-layout blackjack"
                              style={{ position: "relative" }}
                            >
                              <div className="col-12 timerDiv2 mb-negative-24">
                                <BollywoodRules
                                  show={showRules}
                                  onClose={() => setShowRules(false)}
                                />

                                <div
                                  className="row mt-2"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                >
                                  <div className="col-2 col-md-1">
                                    <div className="Connectedclients mt-1">
                                      <i
                                        aria-hidden="true"
                                        className="fa fa-user mr-1"
                                        style={{
                                          fontSize: "14px",
                                          color: "white"
                                        }}
                                      />
                                      <b>
                                        <span
                                          id="UsersCount"
                                          className="number"
                                        >
                                          326
                                        </span>
                                      </b>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className="col-md-8"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                />

                                <div
                                  className="col-md-2"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                >
                                  {/* Timer with animated stroke + numeric countdown */}
                                  <div className="teenpatti-base-timer">
                                    <svg
                                      viewBox="0 0 100 100"
                                      className="base-timer__svg"
                                    >
                                      <g className="base-timer__circle">
                                        <circle
                                          cx="50"
                                          cy="50"
                                          r="45"
                                          className="base-timer__path-elapsed"
                                        />
                                        <path
                                          strokeDasharray={`${Math.round(
                                            dash
                                          )} ${Math.round(CIRC)}`}
                                          className={`base-timer__path-remaining ${timerColor}`}
                                          d="
                                            M 50, 50
                                            m -45, 0
                                            a 45,45 0 1,0 90,0
                                            a 45,45 0 1,0 -90,0
                                          "
                                        />
                                      </g>
                                    </svg>
                                    <span className="base-timer__label">
                                      {payload?.left_time == 1
                                        ? 0
                                        : payload?.left_time}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div
                                className="table-player-bollywood mt-0"
                                style={{
                                  display: activeTabIndex == 1 ? "" : "none"
                                }}
                              >
                                <span
                                  className="name player-dt"
                                  style={{ color: "#d7bc7b" }}
                                >
                                  {getWinnerTitle()}
                                </span>
                                <div
                                  className="bollywood-player pt-2"
                                  style={{
                                    border: "1px solid rgba(178, 220, 175, .25)"
                                  }}
                                >
                                  <div className="tp-bollywood-hand-single bollywood-virtual-hand-single">
                                    <div
                                      className={`tp-card ${payload?.c1 !== "1" ? "flip" : ""
                                        }`}
                                    >
                                      <img
                                        src={`/assets/images/cards/${payload?.c1}.svg`}
                                        draggable={false}
                                        style={{
                                          width: isMobile ? "46px" : "70px",
                                          height: isMobile ? "55px" : "85px"
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <Volume
                                id="BollywoodSoundcontrol"
                                style={{
                                  position: "absolute",
                                  right: 18,
                                  bottom: 8,
                                  zIndex: 100
                                }}
                              />
                              {/* Controls removed (auto mode) */}
                            </div>
                          </div>
                        </div>

                        {/* Footer */}
                        <center
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer">
                            <div className="buttons-div">
                              {Object.keys(resultList).map((idx) => (
                                <button
                                  key={idx}
                                  className="video-button border-gradient-btn border-gradient-purple-btn"
                                >
                                  {resultList[idx]}
                                </button>
                              ))}
                            </div>
                            <div className="round-div">
                              <div className="label">Round ID:</div>
                              <div className="id">{roundId}</div>
                            </div>
                          </div>
                        </center>

                        {/* Market Sections (unchanged) */}
                        <div
                          className="bg-white"
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div
                            className="tb-content"
                            style={{ background: "#fff" }}
                          >
                            <div className="market-titlebar">
                              <p className="market-name">
                                <span className="market-name-badge">
                                  <i className="market-name-icon">
                                    <img
                                      src="/assets/images/time-img.png"
                                      style={{
                                        filter: "invert(100%)",
                                        marginTop: "-8px",
                                        marginLeft: "-1px"
                                      }}
                                    />
                                  </i>
                                  <span>MATCH ODDS </span>
                                </span>
                              </p>
                              <div className="market-overarround">
                                <span />
                                <strong>Back</strong>
                              </div>
                              <div className="market-overarround market-overarround-lay">
                                <strong>Lay</strong>
                              </div>
                            </div>
                            <div className="market-runners">
                              <div className="runner-runner">
                                <h3 className={
                                  donWinner && resultReady
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                } id="b1Sucess">
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontSize: 16,
                                                  fontWeight: "bold"
                                                }}
                                                className="clippable-spacer"
                                              >
                                                Don
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="bstatus1"
                                                style={{
                                                  display:
                                                    done !== 0 ? "" : "none",
                                                  float: "left",
                                                  color:
                                                    done > 0 ? "green" : "red",
                                                  fontWeight: 600
                                                }}
                                              >
                                                {formatTruncate(done)}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {(isSuspended ||
                                    oddsData[0]?.status != 1) && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b1span"
                                    data-teamname="Don"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "don",
                                        "don",
                                        oddsData[0]?.back,
                                        "m",
                                        1
                                      )
                                    }
                                  >
                                    {oddsData[0]?.back}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a
                                    className="price-price price-lay ml-4 mb-show"
                                    id="runner1l1span"
                                    data-teamname="Don"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "l",
                                        "don",
                                        "don",
                                        oddsData[0]?.lay,
                                        "m",
                                        1
                                      )
                                    }
                                  >
                                    {oddsData[0]?.lay}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                              <div className="runner-runner">
                                <h3 className={
                                  amarAkbarAnthonyWinner && resultReady
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                } id="b2Sucess">
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontSize: 16,
                                                  fontWeight: "bold"
                                                }}
                                                className="clippable-spacer"
                                              >
                                                Amar Akbar Anthony
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="bstatus1"
                                                style={{
                                                  display:
                                                    amarakbaranthony !== 0
                                                      ? ""
                                                      : "none",
                                                  float: "left",
                                                  color:
                                                    amarakbaranthony > 0
                                                      ? "green"
                                                      : "red",
                                                  fontWeight: 600
                                                }}
                                              >
                                                {formatTruncate(
                                                  amarakbaranthony
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {(isSuspended ||
                                    oddsData[1]?.status != 1) && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner2b1span"
                                    data-teamname="Amar Akbar Anthony"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "amar akbar anthony",
                                        "amar akbar anthony",
                                        oddsData[1]?.back,
                                        "m",
                                        2
                                      )
                                    }
                                  >
                                    {oddsData[1]?.back}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a
                                    className="price-price price-lay ml-4 mb-show"
                                    id="runner2l1span"
                                    data-teamname="Amar Akbar Anthony"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "l",
                                        "amar akbar anthony",
                                        "amar akbar anthony",
                                        oddsData[1]?.lay,
                                        "m",
                                        2
                                      )
                                    }
                                  >
                                    {oddsData[1]?.lay}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                              <div className="runner-runner">
                                <h3 className={
                                  sahibBibiAurGulamWinner && resultReady
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                } id="b2Sucess">
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontSize: 16,
                                                  fontWeight: "bold"
                                                }}
                                                className="clippable-spacer"
                                              >
                                                Sahib Bibi Aur Gulam
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="bstatus1"
                                                style={{
                                                  display:
                                                    sahibbibiaurghulam !== 0
                                                      ? ""
                                                      : "none",
                                                  float: "left",
                                                  color:
                                                    sahibbibiaurghulam > 0
                                                      ? "green"
                                                      : "red",
                                                  fontWeight: 600
                                                }}
                                              >
                                                {formatTruncate(
                                                  sahibbibiaurghulam
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {(isSuspended ||
                                    oddsData[2]?.status != 1) && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b1span"
                                    data-teamname="Sahib Bibi Aur Gulam"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "sahib bibi aur ghulam",
                                        "sahib bibi aur ghulam",
                                        oddsData[2]?.back,
                                        "m",
                                        3
                                      )
                                    }
                                  >
                                    {oddsData[2]?.back}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a
                                    className="price-price price-lay ml-4 mb-show"
                                    id="runner3l1span"
                                    data-teamname="Sahib Bibi Aur Gulam"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "l",
                                        "sahib bibi aur ghulam",
                                        "sahib bibi aur ghulam",
                                        oddsData[2]?.lay,
                                        "m",
                                        3
                                      )
                                    }
                                  >
                                    {oddsData[2]?.lay}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                              <div className="runner-runner">
                                <h3 className={
                                  dharamVeerWinner && resultReady
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                } id="b2Sucess">
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontSize: 16,
                                                  fontWeight: "bold"
                                                }}
                                                className="clippable-spacer"
                                              >
                                                Dharam Veer
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="bstatus1"
                                                style={{
                                                  display:
                                                    dharamveer !== 0
                                                      ? ""
                                                      : "none",
                                                  float: "left",
                                                  color:
                                                    dharamveer > 0
                                                      ? "green"
                                                      : "red",
                                                  fontWeight: 600
                                                }}
                                              >
                                                {formatTruncate(dharamveer)}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {(isSuspended ||
                                    oddsData[3]?.status != 1) && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b1span"
                                    data-teamname="Dharam Veer"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "Dharam Veer",
                                        "Dharam Veer",
                                        oddsData[3]?.back,
                                        "m",
                                        4
                                      )
                                    }
                                  >
                                    {oddsData[3]?.back}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a
                                    className="price-price price-lay ml-4 mb-show"
                                    id="runner3l1span"
                                    data-teamname="Dharam Veer"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "l",
                                        "Dharam Veer",
                                        "Dharam Veer",
                                        oddsData[3]?.lay,
                                        "m",
                                        4
                                      )
                                    }
                                  >
                                    {oddsData[3]?.lay}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                              <div className="runner-runner">
                                <h3 className={
                                  kisKiskoPyaarKaroonWinner && resultReady
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                } id="b2Sucess">
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontSize: 16,
                                                  fontWeight: "bold"
                                                }}
                                                className="clippable-spacer"
                                              >
                                                Kis Kisko Pyaar Karoon
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="bstatus1"
                                                style={{
                                                  display:
                                                    kiskiskopyarkaru !== 0
                                                      ? ""
                                                      : "none",
                                                  float: "left",
                                                  color:
                                                    kiskiskopyarkaru > 0
                                                      ? "green"
                                                      : "red",
                                                  fontWeight: 600
                                                }}
                                              >
                                                {formatTruncate(
                                                  kiskiskopyarkaru
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {(isSuspended ||
                                    oddsData[4]?.status != 1) && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b1span"
                                    data-teamname="Kis Kisko Pyaar Karoon"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "kis kisko pyar karu",
                                        "kis kisko pyar karu",
                                        oddsData[4]?.back,
                                        "m",
                                        5
                                      )
                                    }
                                  >
                                    {oddsData[4]?.back}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a
                                    className="price-price price-lay ml-4 mb-show"
                                    id="runner5l1span"
                                    data-teamname="Kis Kisko Pyaar Karoon"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "l",
                                        "kis kisko pyar karu",
                                        "kis kisko pyar karu",
                                        oddsData[4]?.lay,
                                        "m",
                                        5
                                      )
                                    }
                                  >
                                    {oddsData[4]?.lay}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                              <div className="runner-runner">
                                <h3 className={
                                  ghulamWinner && resultReady
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                } id="b2Sucess">
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontSize: 16,
                                                  fontWeight: "bold"
                                                }}
                                                className="clippable-spacer"
                                              >
                                                Ghulam
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="bstatus1"
                                                style={{
                                                  display:
                                                    ghulam !== 0 ? "" : "none",
                                                  float: "left",
                                                  color:
                                                    ghulam > 0
                                                      ? "green"
                                                      : "red",
                                                  fontWeight: 600
                                                }}
                                              >
                                                {formatTruncate(ghulam)}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {(isSuspended ||
                                    oddsData[5]?.status != 1) && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b1span"
                                    data-teamname="Ghulam"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "Ghulam",
                                        "Ghulam",
                                        oddsData[5]?.back,
                                        "m",
                                        6
                                      )
                                    }
                                  >
                                    {oddsData[5]?.back}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a
                                    className="price-price price-lay ml-4 mb-show"
                                    id="runner3l1span"
                                    data-teamname="Ghulam"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "l",
                                        "Ghulam",
                                        "Ghulam",
                                        oddsData[5]?.lay,
                                        "m",
                                        6
                                      )
                                    }
                                  >
                                    {oddsData[5]?.lay}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            style={{ height: "5px", background: "#000" }}
                          ></div>

                          {/*- plus -*/}
                          <div
                            className="tb-content"
                            style={{ background: "#fff" }}
                          >
                            <div className="market-titlebar">
                              <p className="market-name">
                                <span className="market-name-badge">
                                  <i className="market-name-icon">
                                    <img
                                      src="/assets/images/time-img.png"
                                      style={{
                                        filter: "invert(100%)",
                                        marginTop: "-8px",
                                        marginLeft: "-1px"
                                      }}
                                    />
                                  </i>
                                  <span>PAIR </span>
                                </span>
                              </p>
                              <div className="market-overarround">
                                <span />
                                <strong>Back</strong>
                              </div>
                              <div className="market-overarround market-overarround-lay">
                                <strong>Lay</strong>
                              </div>
                            </div>
                            <div className="market-runners">
                              <div className="runner-runner">
                                <h3 className={
                                  kqWinner && resultReady
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                } id="b3Sucess">
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontSize: 16,
                                                  fontWeight: "bold"
                                                }}
                                                className="clippable-spacer"
                                              >
                                                K-Q
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="bstatus1"
                                                style={{
                                                  display:
                                                    dulhadulhan !== 0
                                                      ? ""
                                                      : "none",
                                                  float: "left",
                                                  color:
                                                    dulhadulhan > 0
                                                      ? "green"
                                                      : "red",
                                                  fontWeight: 600
                                                }}
                                              >
                                                {formatTruncate(dulhadulhan)}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {(isSuspended ||
                                    oddsData[6]?.status != 1) && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                  <a className="price-price price-back whtBack hide-mobile">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack hide-mobile">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b1span"
                                    data-teamname="DULHA DULHAN"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "DULHA DULHAN",
                                        "DULHA DULHAN",
                                        oddsData[13]?.back,
                                        "f",
                                        14
                                      )
                                    }
                                  >
                                    {oddsData[13]?.back}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a
                                    className="price-price price-lay ml-4 mb-show"
                                    id="runner3l1span"
                                    data-teamname="DULHA DULHAN"
                                    data-bettype="b"
                                  >
                                    <span className="price-amount" id="rate1">
                                      { }
                                    </span>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                              <div className="runner-runner">
                                <h3 className={
                                  jaWinner && resultReady
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                } id="b4Sucess">
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontSize: 16,
                                                  fontWeight: "bold"
                                                }}
                                                className="clippable-spacer"
                                              >
                                                J-A
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="bstatus1"
                                                style={{
                                                  display:
                                                    barati !== 0 ? "" : "none",
                                                  float: "left",
                                                  color:
                                                    barati > 0
                                                      ? "green"
                                                      : "red",
                                                  fontWeight: 600
                                                }}
                                              >
                                                {barati}
                                                {formatTruncate(barati)}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {(isSuspended ||
                                    oddsData[14]?.status != 1) && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b1span"
                                    data-teamname="BARATI"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "BARATI",
                                        "BARATI",
                                        oddsData[14]?.back,
                                        "f",
                                        15
                                      )
                                    }
                                  >
                                    {oddsData[14]?.back}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>

                                  <a
                                    className="price-price price-lay ml-4 mb-show"
                                    id="runner3l1span"
                                    data-teamname="BARATI"
                                    data-bettype="b"
                                  >
                                    <span className="price-amount" id="rate1">
                                      { }
                                    </span>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            style={{ height: "5px", background: "#000" }}
                          ></div>

                          {/*- plus -*/}
                          {/*- plus -*/}
                          <div
                            className="tb-content"
                            style={{ background: "#fff" }}
                          >
                            <div className="market-titlebar">
                              <p className="market-name">
                                <span className="market-name-badge">
                                  <i className="market-name-icon">
                                    <img
                                      src="/assets/images/time-img.png"
                                      style={{
                                        filter: "invert(100%)",
                                        marginTop: "-8px",
                                        marginLeft: "-1px"
                                      }}
                                    />
                                  </i>
                                  <span>COLOR</span>
                                </span>
                              </p>
                              <div className="market-overarround">
                                <span />
                                <strong>Back</strong>
                              </div>
                              <div className="market-overarround market-overarround-lay">
                                <strong>Lay</strong>
                              </div>
                            </div>
                            <div className="market-runners">
                              <div className="runner-runner">
                                <h3 className={
                                  redWinner && resultReady
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                } id="b4Sucess">
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontSize: 16,
                                                  fontWeight: "bold"
                                                }}
                                                className="clippable-spacer"
                                              >
                                                RED
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="bstatus1"
                                                style={{
                                                  display:
                                                    red !== 0 ? "" : "none",
                                                  float: "left",
                                                  color:
                                                    red > 0 ? "green" : "red",
                                                  fontWeight: 600
                                                }}
                                              >
                                                {formatTruncate(red)}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {(isSuspended ||
                                    oddsData[7]?.status != 1) && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b1span"
                                    data-teamname="Red"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "Red",
                                        "Red",
                                        oddsData[7]?.back,
                                        "f",
                                        8
                                      )
                                    }
                                  >
                                    {oddsData[7]?.back}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a
                                    className="price-price price-lay ml-4 mb-show"
                                    id="runner3l1span"
                                    data-teamname="Red"
                                    data-bettype="b"
                                  >
                                    <span className="price-amount" id="rate1">
                                      { }
                                    </span>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                              <div className="runner-runner">
                                <h3 className={
                                  blackWinner && resultReady
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                } id="b3Sucess">
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontSize: 16,
                                                  fontWeight: "bold"
                                                }}
                                                className="clippable-spacer"
                                              >
                                                BLACK
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="bstatus1"
                                                style={{
                                                  display:
                                                    black !== 0 ? "" : "none",
                                                  float: "left",
                                                  color:
                                                    black > 0 ? "green" : "red",
                                                  fontWeight: 600
                                                }}
                                              >
                                                {formatTruncate(black)}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {(isSuspended ||
                                    oddsData[8]?.status != 1) && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b1span"
                                    data-teamname="Black"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "Black",
                                        "Black",
                                        oddsData[8]?.back,
                                        "f",
                                        9
                                      )
                                    }
                                  >
                                    {oddsData[7]?.back}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>

                                  <a
                                    className="price-price price-lay ml-4 mb-show"
                                    id="runner3l1span"
                                    data-teamname="Black"
                                    data-bettype="b"
                                  >
                                    <span className="price-amount" id="rate1">
                                      { }
                                    </span>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            style={{ height: "5px", background: "#000" }}
                          ></div>

                          {/*- plus -*/}
                          {/*- plus -*/}
                          <div
                            className="tb-content"
                            style={{ background: "#fff" }}
                          >
                            <div className="market-titlebar">
                              <p className="market-name">
                                <span className="market-name-badge">
                                  <i className="market-name-icon">
                                    <img
                                      src="/assets/images/time-img.png"
                                      style={{
                                        filter: "invert(100%)",
                                        marginTop: "-8px",
                                        marginLeft: "-1px"
                                      }}
                                    />
                                  </i>
                                  <span>Cards 3.75 </span>
                                </span>
                              </p>
                              <div className="market-overarround">
                                <span />
                                <strong>Back</strong>
                              </div>
                              <div className="market-overarround market-overarround-lay">
                                <strong>Lay</strong>
                              </div>
                            </div>
                            <div className="market-runners">
                              <div className="runner-runner">
                                <h3 className={
                                  jCardWinner && resultReady
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                } id="b3Sucess">
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontSize: 16,
                                                  fontWeight: "bold"
                                                }}
                                                className="clippable-spacer"
                                              >
                                                J
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="bstatus1"
                                                style={{
                                                  display:
                                                    cardj !== 0 ? "" : "none",
                                                  float: "left",
                                                  color:
                                                    cardj > 0 ? "green" : "red",
                                                  fontWeight: 600
                                                }}
                                              >
                                                {formatTruncate(cardj)}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {(isSuspended ||
                                    oddsData[9]?.status != 1) && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b1span"
                                    data-teamname="Card J"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "Card J",
                                        "Card J",
                                        oddsData[9]?.back,
                                        "f",
                                        10
                                      )
                                    }
                                  >
                                    {oddsData[9]?.back}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a
                                    className="price-price price-lay ml-4 mb-show"
                                    id="runner3l1span"
                                    data-teamname="Card J"
                                    data-bettype="b"
                                  >
                                    <span className="price-amount" id="rate1">
                                      { }
                                    </span>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                              <div className="runner-runner">
                                <h3 className={
                                  qCardWinner && resultReady
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                }
                                  id="b4Sucess">
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontSize: 16,
                                                  fontWeight: "bold"
                                                }}
                                                className="clippable-spacer"
                                              >
                                                Q
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="bstatus1"
                                                style={{
                                                  display:
                                                    cardq !== 0 ? "" : "none",
                                                  float: "left",
                                                  color:
                                                    cardq > 0 ? "green" : "red",
                                                  fontWeight: 600
                                                }}
                                              >
                                                {formatTruncate(cardq)}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {(isSuspended ||
                                    oddsData[10]?.status != 1) && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b1span"
                                    data-teamname="Card Q"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "Card Q",
                                        "Card Q",
                                        oddsData[10]?.back,
                                        "f",
                                        11
                                      )
                                    }
                                  >
                                    {oddsData[10]?.back}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a
                                    className="price-price price-lay ml-4 mb-show"
                                    id="runner3l1span"
                                    data-teamname="Card Q"
                                    data-bettype="b"
                                  >
                                    <span className="price-amount" id="rate1">
                                      { }
                                    </span>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                              <div className="runner-runner">
                                <h3 className={
                                  kCardWinner && resultReady
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                } id="b4Sucess">
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontSize: 16,
                                                  fontWeight: "bold"
                                                }}
                                                className="clippable-spacer"
                                              >
                                                K
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="bstatus1"
                                                style={{
                                                  display:
                                                    cardk !== 0 ? "" : "none",
                                                  float: "left",
                                                  color:
                                                    cardk > 0 ? "green" : "red",
                                                  fontWeight: 600
                                                }}
                                              >
                                                {formatTruncate(cardk)}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {(isSuspended ||
                                    oddsData[11]?.status != 1) && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b1span"
                                    data-teamname="Card K"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "Card K",
                                        "Card K",
                                        oddsData[11]?.back,
                                        "f",
                                        12
                                      )
                                    }
                                  >
                                    {oddsData[11]?.back}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>

                                  <a
                                    className="price-price price-lay ml-4 mb-show"
                                    id="runner3l1span"
                                    data-teamname="Card K"
                                    data-bettype="b"
                                  >
                                    <span className="price-amount" id="rate1">
                                      { }
                                    </span>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                              <div className="runner-runner">
                                <h3 className={
                                  aCardWinner && resultReady
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                } id="b4Sucess">
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontSize: 16,
                                                  fontWeight: "bold"
                                                }}
                                                className="clippable-spacer"
                                              >
                                                A
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="bstatus1"
                                                style={{
                                                  display:
                                                    carda !== 0 ? "" : "none",
                                                  float: "left",
                                                  color:
                                                    carda > 0 ? "green" : "red",
                                                  fontWeight: 600
                                                }}
                                              >
                                                {formatTruncate(carda)}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {(isSuspended ||
                                    oddsData[12]?.status != 1) && (
                                      <div
                                        className="runner-disabled2"
                                        id="suspendCls1"
                                      >
                                        {suspendedText}
                                      </div>
                                    )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b1span"
                                    data-teamname="Card A"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "Card A",
                                        "Card A",
                                        oddsData[12]?.back,
                                        "f",
                                        13
                                      )
                                    }
                                  >
                                    {oddsData[12]?.back}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a
                                    className="price-price price-lay ml-4 mb-show"
                                    id="runner3l1span"
                                    data-teamname="Card A"
                                    data-bettype="b"
                                  >
                                    <span className="price-amount" id="rate1">
                                      { }
                                    </span>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                            </div>
                            {/*- plus -*/}
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          display: activeTabIndex == 2 ? "" : "none",
                          color: "white"
                        }}
                      >
                        <BollywoodResult resultData={resultData} />
                      </div>
                    </div>

                    <div className="col-md-4">
                      {showBetSlipPopup && (
                        <TPPopUpBetSlip
                          closeBetSlipParent={closeBetSlipMobile}
                          betObj={placeBetObject}
                          placeBetParent={placeBet}
                          betButtonShow={betButtonShow}
                          betErrorMessageObj={betErrorMessageObj}
                          betButtonShowLoaderShow={betButtonShowLoaderShow}
                          profileData={profileData}
                        />
                      )}
                      <TeenPattisCasinoBetslipWeb
                        showBetSlip={showBetSlip}
                        placeBetObject={placeBetObject}
                        closeBetSlipParent={closeBetSlip}
                        placeBetParent={placeBet}
                        betErrorMessageObj={betErrorMessageObj}
                        profileData={profileData}
                      ></TeenPattisCasinoBetslipWeb>
                      <div>
                        <div className="bets">
                          <strong>
                            Matched Bets (0)
                            <img
                              src={reconnecting}
                              alt="dc"
                              className="rounded disconnected"
                              style={{ display: "none" }}
                            />{" "}
                          </strong>
                          <div className="betting-table">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>Runner</th>
                                  <th>Price</th>
                                  <th>Size</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {placedBets.map((bet, index) => {
                                  console.log("MATCHED BET:", bet);

                                  return (
                                    <tr
                                      key={index}
                                      style={{
                                        background:
                                          bet.type == "b"
                                            ? "#e9f6fc"
                                            : "#fce3e4"
                                      }}
                                    >
                                      <td>
                                        {displayRunnerName(bet.rnr)} - ({bet.cat_mid})
                                      </td>

                                      <td>{bet.amnt}</td>
                                      <td>{bet.rate}</td>
                                      <td></td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ClientLayoutWithOutHeader>
      <style>
        {`

            .bollywood-virtual-scope .home-content {
              margin-top: -5px !important;
            }

            .bollywood-virtual-scope .timerDiv2 .col-md-2 {
              position: relative;
              right: -10px;
            }

            .mt-0, .my-0 {
              margin-top: 40px !important;
            }
            .bollywood-player {
              width: 170px!important;
              height: 93px!important;
            }
            .player-scope .table-player .player {
              width: 210px !important;
            }
            .player-scope .table-player {
              gap: 9px !important;
              align-items: center;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              height: auto !important;
              min-height: auto !important;
            }
            .player-scope .table-player .player-dt {
              display: flex !important;
              flex-direction: column;
              align-items: center !important;
              max-width: none;
              width: auto;
              color: #d7bc7b !important;
              font-size: 12px;
              font-weight: 700;
            }
            @media (min-width: 768px) {
              .left-content center,
              .left-content .bg-white {
                margin-left: 10px;
              }
            }
            @media (min-width:992px){
              .cards-layout.blackjack {
                min-height: 240px;
              }
              .volume-wrapper {
                margin-top: -15px;
              }
            }  
            /* mobile */  
            @media (max-width:576px){
              .mob-margin{
                margin-left: 5px;
                margin-right: 5px;
              }
              .cards-layout.blackjack {
                min-height: 120px !important;
              }
              .player-scope .table-player .player {
                width: 170px !important;
                height: 70px !important;
              }
              .titlebarname p{
                font-size: 14px;
              }
              .cards-layout.blackjack .col-12{
                padding-left:0;
                padding-right:0;
              }
              .tp-card img{
                height: 55px;   
                width: auto;
                border-radius: 3px;
              }
              .volume-wrapper {  
                height: 10px !important;
                margin-top: -7px !important;
                line-height: 16px;
                margin-bottom: 10px;
              }
              .hide-mobile {
                display: none !important;
              }
              .bollywood-virtual-scope .table-player-bollywood.mt-0 {
                margin-top: 0 !important;
                margin-bottom: 10px !important;
              }
              .bollywood-virtual-scope .table-player-bollywood .bollywood-virtual-hand-single {
                margin-bottom: 10px !important;
              }
            }  
            
            .player-card {
                height: 100px !important;
            }   
            .tp-card {
              top: 10px !important;  
            }  
            .tp-card img{
              height: 73px;   
              width: auto;
              border-radius: 3px;
            }
            .table-player-bollywood {
              display: flex;
              justify-content: center;
              align-items: center !important;
              flex-direction: column;
              padding-top: 0 !important;
              padding-bottom: 0 !important;
            } 
          `}
      </style>
    </div>
  );
}
